import API from '../baseService';

export const resetPasswordResults = params =>
  API.post('/forgot', { ...params });
